export default __webpack_public_path__ + "static/media/tutorial-pc_5.2b84a6ad.svg";